import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { API } from '../api';
import authReducer from './authSlice';

const reducers = combineReducers({
  [API.reducerPath]: API.reducer,
  auth: authReducer
})

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
      }}).concat(API.middleware)
  }
})
